import React from "react";
import { AppComponent } from "../shared-components/AppComponent";
import type { IAppLegal } from "./AppLegal";
import { ImpressumComponent } from "./impressum/ImpressumComponent";
import { ResponsibleDisclosureComponent } from "./responsible-disclosure/ResponsibleDisclosureComponent";
import { PrivacyPolicyComponent } from "./privacy/PrivacyPolicyComponent";
import { CookiePolicyComponent } from "./cookie/CookiePolicyComponent";
import { OopsPageErrorCatchingComponent } from "../shared-components/error-catching-component/OopsPageErrorCatchingComponent";

interface ILegalComponentProps {
    appLegal: IAppLegal;
}

export class LegalComponent extends React.Component<ILegalComponentProps> {
    render() {
        const { appLegal } = this.props;
        const { stores } = appLegal;

        return (
            <OopsPageErrorCatchingComponent isLandingPage={true}>
                <AppComponent appStores={stores}>
                    <div id={"legal-component"}>
                        <PrivacyPolicyComponent />
                        <CookiePolicyComponent />
                        <ResponsibleDisclosureComponent />
                        <ImpressumComponent />
                    </div>
                </AppComponent>
            </OopsPageErrorCatchingComponent>
        );
    }
}
